export default __webpack_public_path__ + "static/media/ask-to-join.9f32f5a7.mp3";